module.exports = __webpack_public_path__ + "images/illustrations/icons/icon-gradcap-1e7e074e8b0504da42c2659a5ec6e8c7.webp";